import vue from 'vue'
import 'bootstrap'
import 'jquery-slimscroll'
import swal from 'sweetalert2'
import pt from 'vee-validate/dist/locale/pt_BR';
import VeeValidate, {Validator} from 'vee-validate'


window.swal = swal

import VueTheMask from 'vue-the-mask'
import VueMoney from 'v-money';
import vSelect from 'vue-select'

vue.use(VueMoney, {decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2});
vue.use(VueTheMask);
vue.component('v-select', vSelect);

vue.use(VeeValidate);
Validator.localize('pt_BR', pt);


require('jquery-datetimepicker');
require('jquery-datetimepicker/jquery.datetimepicker.css');

jQuery.datetimepicker.setLocale('pt-BR');

